import { useContext, useEffect } from "react";

import { MapContext, MapLoadedContext } from "./Map";

interface RasterLayerInfo {
  name: string;
  url: string;
  bounds: [number, number, number, number];
}

const RasterLayer = (props: { rasterLayerInfos: RasterLayerInfo[] }) => {
  const map = useContext(MapContext);
  const mapLoaded = useContext(MapLoadedContext);
  const { rasterLayerInfos } = props;
  useEffect(() => {
    if (!mapLoaded || !map) {
      return;
    }
    var layers = map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    // This has the effect of inserting the new layers behind symbols like
    // place names and road names
    let firstSymbolId: string | undefined = undefined;
    if (layers) {
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol") {
          firstSymbolId = layers[i].id;
          break;
        }
      }
    }

    rasterLayerInfos.forEach((rasterLayerInfo) => {
      if (!map.getSource(`${rasterLayerInfo.name}-source`)) {
        map.addSource(`${rasterLayerInfo.name}-source`, {
          type: "raster",
          tiles: [rasterLayerInfo.url],
          tileSize: 256,
          bounds: rasterLayerInfo.bounds,
        });
        map.addLayer(
          {
            id: `${rasterLayerInfo.name}-layer`,
            type: "raster",
            source: `${rasterLayerInfo.name}-source`,
          },
          firstSymbolId
        );
      }
    });
  }, [map, mapLoaded, rasterLayerInfos]);

  return null;
};

export default RasterLayer;
